import { getRandomNumber } from '@/utils/number';

export const ORIGIN_LOCATION_SAMPLE_DATA = [
  {
    label: 'Austin, TX',
    city: 'Austin',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Arlington, TX',
    city: 'Arlington',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Houston, TX',
    city: 'Houston',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Shanghai, TX',
    city: 'Shanghai',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Burlington, TX',
    city: 'Burlington',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Atlanta, TX',
    city: 'Atlanta',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Washington, CA',
    city: 'Washington',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Stock Bridge, TX',
    city: 'Stock B',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Oklahoma City, TX',
    city: 'Oklahoma City',
    stateCode: 'TX',
    stateName: 'Texas',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'USA',
  },
  {
    label: 'Beijing, TX',
    city: 'Beijing',
    stateCode: 'TX',
    stateName: 'Beijing',
    pickup: getRandomNumber(),
    delivery: getRandomNumber(),
    countryName: 'China',
  },
];

export const PRODUCT_CHART_SAMPLE_DATA = [
  {
    productCode: 'PGD120H240',
    counts: getRandomNumber(2),
    productDesc: '10 TON GAS PKG.',
  },
  {
    productCode: 'MICROFRIDG2',
    counts: getRandomNumber(2),
    productDesc: '#MFA3-AUTO DEFROST',
  },
  {
    productCode: 'CA5518VKD ',
    counts: getRandomNumber(2),
    productDesc: '1.5T 10SEER C/U',
  },
  {
    productCode: 'CA18K-1T  ',
    counts: getRandomNumber(2),
    productDesc: '1.5TON COND UNIT A/C',
  },
  {
    productCode: 'NTGM100EHA',
    counts: getRandomNumber(2),
    productDesc: '100K FURNACE-GAS',
  },
  {
    productCode: '690-107-00',
    counts: getRandomNumber(2),
    productDesc: '12&24 SLOT CABINET PACKAGE CASE',
  },
  {
    productCode: 'RCGA37A1A ',
    counts: getRandomNumber(2),
    productDesc: '2.5T COIL UNCASED',
  },
  {
    productCode: 'WRKA-A030J',
    counts: getRandomNumber(2),
    productDesc: '2.5 GAS PACK',
  },
  {
    productCode: 'TABLE TOP ',
    counts: getRandomNumber(2),
    productDesc: '36" ROUND SLATE FIN.',
  },
  {
    productCode: '25" TV',
    counts: getRandomNumber(2),
    productDesc: 'COMM. W/REMOTE',
  },
];

export const CLAIMS_BY_STATUS_SAMPLE_DATA = [
  { label: 'Open', value: 234 },
  { label: 'Hold', value: 104 },
  { label: 'Pre-Claim', value: 8 },
  { label: 'Closed', value: 345 },
];

export const CLAIMS_BY_REASONS_SAMPLE_DATA = [
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Clear Delivery',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Concealed',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Credit Issued',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Declined by Carrier',
  },
  {
    value: Number.parseInt(Math.random() * 1000),
    label: 'Duplicate',
  },
];
